import { Common, Widget } from '@stockbit/ui';
import { useDispatch, useSelector } from 'react-redux';

import { handleClickSupport } from 'utils/crisp';
import { selectors as profileSelectors } from 'lib/entities/profile';
// eslint-disable-next-line import/named
import usePaywallWidget from 'features/paywall/store/useWidget';

import { useEffect } from 'react';
import sockerSlice, { alertWsSelector } from 'global/WebSocket/slice';
import useSearchCompanyModalStore from 'global/Securities/stores/useSearchCompanyModalStore';
import slice, { selectors } from '../slice';
import BandarDetector from './BandarDetector';
import PriceAlert from './PriceAlert';
import RunningTrade from './RunningTrade';
import Valuation from './Valuation';
import Watchlist from './Watchlist';
import { CLEVERTAP_EVENT_NAME } from '../../../constants/clevertap';
import { clevertapEvent } from '../../../utils/clevertap';

import {
  Container,
  WidgetContainer,
  WidgetWrapper,
  ButtonWidget,
} from './styled';
import { generateSidewidget } from './utils';
import { SIDE_MENU_KEY } from './constants';
import orderbookSlice from './Watchlist/Orderbook/slice';
import valuationWidgetSlice from './Valuation/slice';
import {
  INITIAL_PAGE,
  KENNETH_FISHER_PRICE_TO_SALES_ID,
} from './Valuation/constants';
import Movers from './Movers';

const PRICE_ALERT_KEY = 'price-alert';

const { Iconmoon } = Common;
const { Tooltip } = Widget;

function SideWidget() {
  const dispatch = useDispatch();
  const { current, isSideWidgetOpen, bandarDetectorActiveKey } =
    useSelector(selectors);
  const {
    data: { country },
  } = useSelector(profileSelectors);
  const isShowSearchCompanyModal = useSearchCompanyModalStore((s) => s.visible);

  const alert = useSelector(alertWsSelector) as Record<string, any> | null;

  const { isPro, isAddonPro, addCounter } = usePaywallWidget(current);

  const clearPriceAlert = () => {
    dispatch(sockerSlice.actions.clearAlert());
    localStorage.removeItem(PRICE_ALERT_KEY);
  };

  useEffect(() => {
    if (!isSideWidgetOpen && current !== SIDE_MENU_KEY.ALL_WATCHLIST) {
      dispatch(orderbookSlice.actions.setSymbol({ symbol: 'IHSG' }));
    }

    if (!isSideWidgetOpen) {
      dispatch(
        // @ts-ignore
        valuationWidgetSlice.actions.setCurrentScreenerData({
          page: INITIAL_PAGE,
          presetId: KENNETH_FISHER_PRICE_TO_SALES_ID,
          isDataLoaded: false,
          type: '',
        }),
      );
    }
  }, [isSideWidgetOpen]);

  // hide sidewidget while search company modal is showing
  if (isShowSearchCompanyModal) {
    return <div />;
  }

  return (
    <WidgetContainer>
      <WidgetWrapper isOpen={isSideWidgetOpen}>
        {current === SIDE_MENU_KEY.ALL_WATCHLIST && <Watchlist />}
        {current === SIDE_MENU_KEY.PRICE_ALERT && <PriceAlert isPro={isPro} />}
        {current === SIDE_MENU_KEY.RUNNING_TRADE && (
          <RunningTrade isPro={isPro} />
        )}
        {current === SIDE_MENU_KEY.MOVERS && <Movers />}
        {current === SIDE_MENU_KEY.VALUATION && (
          <Valuation isPro={isPro} isProScreener={isAddonPro} />
        )}
        {current === SIDE_MENU_KEY.BANDAR_DETECTOR && (
          <BandarDetector isPro={isPro} activeKey={bandarDetectorActiveKey} />
        )}
      </WidgetWrapper>
      <Container>
        {generateSidewidget(country).map(({ key, icon, text, eventName }) => {
          const isPriceAlert =
            key === SIDE_MENU_KEY.PRICE_ALERT && !!alert?.msg;
          return (
            <Tooltip key={`watchlist-${key}`} placement="left" title={text}>
              <ButtonWidget
                active={current === key}
                onClick={() => {
                  if (eventName && current !== key) {
                    clevertapEvent(CLEVERTAP_EVENT_NAME.SIDE_MENU, {
                      Action: eventName,
                    });

                    addCounter(key);
                  }

                  if (isPriceAlert) {
                    clearPriceAlert();
                  }
                  // @ts-ignore
                  dispatch(slice.actions.setActiveWidget({ key }));
                }}
                data-cy={`right-menu-${eventName}`}
                $shouldRenderAfter={isPriceAlert}
              >
                <Iconmoon
                  className={icon}
                  color="inherit"
                  hoverColor="inherit"
                  size="20px"
                />
              </ButtonWidget>
            </Tooltip>
          );
        })}
        <Tooltip key="support" placement="left" title="Support">
          <ButtonWidget
            data-cy="right-menu-support"
            onClick={handleClickSupport}
          >
            <div className="intercom-unread-count" />
            <Iconmoon
              className="icon-widget_support"
              color="inherit"
              hoverColor="inherit"
              size="20px"
            />
          </ButtonWidget>
        </Tooltip>
      </Container>
    </WidgetContainer>
  );
}

export default SideWidget;
